import { makeStyles } from '@mui/styles';
import { IconButton } from 'apollo-react';
import TextField from 'apollo-react/components/TextField';
import Search from 'apollo-react-icons/Search';
import React, { useEffect, useState } from 'react';

import LookupPopover from './LookupPopover';

const useStyles = makeStyles({
  root: {
    minWidth: 200,
    margin: 3,
    paddingRight: 3,
  },
});

const EditableCell = ({
  row,
  column: {
    accessor: key,
    enableLookup = false,
    enableLookupCopy = false,
    lookupValues = [],
    required,
  },
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(row[key]);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [popoverAnchor, setPopoverAnchor] = useState(null);
  const error = row.errors?.find((error) => error?.controlInfo?.prop === key);

  useEffect(() => {
    setValue(row[key]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row[key]]);

  const onBlur = ({ target }) => {
    if (row[key] === target.value) {
      return;
    }
    row.editRow({ rowId: row.rowId, key, value: target.value, error });
  };

  const handleLookupBtnClick = (e) => {
    setPopoverOpen(true);
    setPopoverAnchor(e.currentTarget);
  };

  const onPopoverClose = () => {
    setPopoverOpen(false);
  };

  const handleValueSelect = (value) => {
    row.editRow({ rowId: row.rowId, key, value, error });
    onPopoverClose();
  };

  const handleOnClick = () => {
    row.handleSelectRow && row.handleSelectRow({ rowId: row.rowId });
  };

  return (
    <>
      <TextField
        fullWidth
        className={classes.root}
        asteriskPosition="before"
        size="small"
        icon={
          enableLookup ? (
            <IconButton size="small" aria-label="Search">
              <Search style={{ color: '#0768fd' }} />
            </IconButton>
          ) : (
            <></>
          )
        }
        iconProps={{
          onClick: (e) => handleLookupBtnClick(e),
        }}
        value={value}
        onChange={({ target }) => setValue(target.value)}
        onBlur={onBlur}
        onClick={handleOnClick}
        required={required}
        error={!!error}
        InputProps={{
          inputProps: {
            'aria-label': 'Input Field',
          },
        }}
      />
      {enableLookup && (
        <LookupPopover
          open={popoverOpen}
          anchorEl={popoverAnchor}
          onClose={onPopoverClose}
          options={lookupValues}
          onSelect={handleValueSelect}
          enableCopy={enableLookupCopy}
        />
      )}
    </>
  );
};
export default EditableCell;
